module.exports = __webpack_public_path__ + "static/media/isp-blockchain-iot.5bf67ec4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/isp-blockchain-iot.jpg
// module id = 861
// module chunks = 1